import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon-search',
  standalone: true,
  template: `
    <svg [class]="svgClass" fill="none" [attr.stroke]="color" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
    </svg>
  `
})
export class IconSearchComponent {
  @Input() svgClass: string = 'w-4 h-4 mr-2';
  @Input() color: string = 'white';
}
